<template>
    <div
        class="swiper-slide swiper-slide-height"
        :tabindex="tabIndex"
        :class="{'initial-swiper-slide': isInitialSwiperSlide}"
    >
        <slot />
    </div>
</template>

<script>

export default {
    name: "SwiperSlide",
    props: {
        isInitialSwiperSlide: {type: Boolean, required: false, default: false},
        tabIndex: {type: Number, required: false, default: 0}
    },
}
</script>

<style scoped lang="scss">

// hack hauteur tuiles noires EDITO
.swiper-slide-height {
    height: auto !important;
}

</style>
